import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LocalizedLink = ({ to, ...props }: LinkProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'es';
  
  const localizedTo = typeof to === 'string' 
    ? (to.startsWith('/') ? `/${lang}${to === '/' ? '' : to}` : to)
    : to;

  return <Link to={localizedTo} {...props} />;
};
